import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import { postInWindow, handlePostData, openPopUpWindow } from '../../utils/formPost';
import {
  calculateAmountPayable,
  staticPath,
  convertRupeeCharToUnicode,
  getEncodedQs,
  getKey,
  clientMessage,
  getIframeRequestPayload,
  findIndex,
  updatePayloadForTenureEMI,
  updatePayloadForValidateEMI,
  isHybridOrAddNPay
} from '../../utils/common';

import CONSTANT, { CACHE, EVENTS } from '../../utils/constants';
import { API, TOKEN, PAYMODE, FLOW } from '../../../../common/src/constant';
import EmiBankList from '../emiBankList';
import EmiPlansList from '../emiPlans';
import SC from '../sc';
import Iframe from '../iframe';
import MiniCart from '../miniCart';
import { emiApi } from '../../controllers/emi';
import Loader from '../loader';
import LOCALE from '../../locale/en';
import { EVENT, log } from '../../common/logger';
import OverlayWrap from '../OverlayWrap';
import PaymodeOffer from '../offers/paymodeOffer';
import { getApplyPromoBaseRequestObj, isPromoAvailable } from '../../controllers/offers';

class EMI extends Component {
  hasValidationError = true;

  hiddenInputRef = '';

  constructor(props) {
    super(props);
    const locale = clientMessage(PAYMODE.CARD.toLowerCase(), this.props.cache);
    const emiLocale = clientMessage(PAYMODE.EMI.toLowerCase(), this.props.cache);
    const { query, data } = this.props.cache.getData(CACHE.API).requestPayload(API.BIN);
    data.body = { ...query };
    const payloadData = this.props.cache.getData(CACHE.API).requestPayload(API.CARD_DETAILS);
    const fetchCardQuery = payloadData.query;
    const fetchCardData = payloadData.data;
    fetchCardData.body = { ...fetchCardQuery };
    const newStyle = `.ptm-card-input:focus{
      border-color:${this.props.AppStyle.themeBackgroundColor};
      caret-color:${this.props.AppStyle.themeBackgroundColor};
    }
    #mm:focus+span+input+p.hidden-border,#yy:focus+p.hidden-border{
      background:${this.props.AppStyle.themeBackgroundColor};
      border-color:transparent;
    }
    .ptm-change-plan{
      background:${this.props.AppStyle.bodyBackgroundColor};
      border:1px solid ${this.props.AppStyle.borderColor || '#86a0c2'};
    }
    .card-content{
      border-color:${this.props.AppStyle.borderColor};
      color:${this.props.AppStyle.bodyColor};
    }
    .ptm-card-input,.ptm-emi-bank-select,.card-expiry{
      border-color:${this.props.AppStyle.borderColor};
      color:${this.props.AppStyle.bodyColor};
    }
    
    .ptm-emi-bank-select:after{
      border-color:${this.props.AppStyle.borderColor};
    }
    .ptm-msg-red {
      color: #ff585d;
    }
    #changeCard,#changePlan{
      color:${this.props.AppStyle.themeBackgroundColor};
    }
    .ptm-card-input::placeholder,#save-card-container,.ptm-paymode-name,.ptm-total-amount,.ptm-emi-cal,#shortCardNumber,.slash{
      color:${this.props.AppStyle.bodyColor};
    }
    .hidden-border{
      background-color: ${this.props.AppStyle.borderColor};
    }
    .ptm-check, .ptm-container:hover input ~ .ptm-check{
      border-color: ${this.props.AppStyle.bodyColor};
    }
    .ptm-container input:checked ~ .ptm-check{
      background-color: ${this.props.AppStyle.themeBackgroundColor};
      border: 2px solid ${this.props.AppStyle.themeBackgroundColor};
    }`;
    const isEmiSubventionFlow = this.props.cache.getData(
      CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW
    );
    const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    this.state = {
      showBankList: false,
      showSavedCard: false,
      savedCardPayMode: null,
      bankLabel: 'Select Bank',
      useAnotherCard: false,
      showEmiPlans: false,
      selectedPlan: null,
      planDetails: null,
      selectedCard: null,
      bankError: false,
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: this.props.option.type,
          id: this.props.option.id
        },
        requestPayload: getIframeRequestPayload(this.props.cache, API.BIN),
        requestCacheCardTokenPayload: isEmiSubventionFlow
          ? getIframeRequestPayload(this.props.cache, API.CACHE_CARD_TOKEN)
          : {},
        // in case it is emi subvention flow do not call card Details since after card completion two api calls would be going unncecessarily
        requestCardDetailsPayload: !isEmiSubventionFlow
          ? getIframeRequestPayload(this.props.cache, API.CARD_DETAILS)
          : {},
        style: newStyle,
        messageObj: {
          label: locale.label,
          error: locale.error,
          emiLabel: emiLocale.label,
          emiError: emiLocale.error
        },
        instanceKey: this.props.instanceKey,
        isEmiSubventionFlow,
        customerId: getKey(mConfig, 'emiSubvention.customerId', null),
        mid: this.props.cache.getData(CACHE.MID)
      },
      loader: false,
      errorHeading: '',
      errorSubText: '',
      bankListError: ''
    };
    this.frame = undefined;
  }

  getApplyPromoBaseRequestPayload() {
    if (!isPromoAvailable(this.props.cache)) {
      return null;
    }

    const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const customerId = getKey(mConfig, 'emiSubvention.customerId', null);
    const payload = getIframeRequestPayload(this.props.cache, API.APPLY_PROMO);
    payload.requestData.body = {
      ...payload.requestData.body,
      ...getApplyPromoBaseRequestObj(this.props.cache, customerId)
    };

    return payload;
  }

  updateinitializeObject() {
    this.setState(prevState => ({
      initializeObject: {
        ...prevState.initializeObject,
        applyPromoRequestPayload: this.getApplyPromoBaseRequestPayload()
      }
    }));
  }

  // focusOnHiddenInput = () => {
  //   setTimeout(() => {
  //     const hiddenInput = document.getElementById('ptm-hidden-input');
  //     isMobileDevice() && !isIphoneDevice() && hiddenInput && hiddenInput.focus();
  //   }, 50);
  // };

  componentDidUpdate(previousProps) {
    // when paymode is changed reset all data
    const optionId = getKey(this.props, 'option.id', null);
    const selectedId = getKey(this.props, 'selected.id', null);
    const previousPropsWallet = getKey(previousProps, 'wallet', null);
    const currentPropsWallet = getKey(this.props, 'wallet', null);
    if (
      optionId &&
      selectedId &&
      optionId === selectedId &&
      previousPropsWallet &&
      currentPropsWallet &&
      currentPropsWallet.isUsed !== previousPropsWallet.isUsed
    ) {
      this.setState({ selectedPlan: null, showEmiPlanDetails: false });
      this.frame &&
        this.frame &&
        this.frame.postDataToIframe({
          type: CONSTANT.HIDE_SAVED_CARD_AND_PLAN,
          paymode: { id: this.props.option.id, type: this.props.option.type }
        });
      this.props.onSelectedPlan(null);
    }
    if (selectedId && optionId && optionId !== selectedId) {
      if (this.state.bankLabel !== 'Select Bank') {
        this.setState({
          bankLabel: 'Select Bank',
          showSavedCard: false,
          savedCardPayMode: null,
          selectedCard: null,
          useAnotherCard: false
        });
        this.props.onSelectedPlan(null);
      }
      /* if option has changed then remove the local selected plan from payment */
      if (!this.props.selectedEmiPlan && this.state.selectedPlan) {
        this.setState({ selectedPlan: null });
      }
    }
  }

  getBankList = () => {
    if (!this.props.cache.getData(CACHE.EMI_BANK_LIST)) {
      this.setState({ loader: true });
      // get call from cart for getting the bank list
      log({
        eventType: EVENTS.EMI_FETCH_BANK
      });
      const subventionObject = this.props.cache.getData(CONSTANT.SUBVENTION_OBJ);
      emiApi(this.props.cache)
        .getBankList(subventionObject)
        .then(emiBankList => {
          /* in case of 3rd party EMI subvention returning error for the same */
          this.props.cache.getData(CACHE.STORE).setState({ stopScroll: true });
          this.setState({ showBankList: true, loader: false, bankListError: '' });
          this.props.cache.setData(CACHE.EMI_BANK_LIST, emiBankList);
        })
        .catch(error => {
          log({
            eventType: EVENTS.EMI_FETCH_BANK_ERROR,
            error
          });
          this.props.cache.setData(CACHE.EMI_BANK_LIST, null);
          this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
          this.setState({
            showBankList: false,
            loader: false,
            bankListError: error.message
          });
          const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
          const notifyMerchant = getKey(config, 'handler.notifyMerchant', undefined);
          if (notifyMerchant && notifyMerchant.constructor === Function) {
            notifyMerchant(
              CONSTANT.NOTIFY_MERCHANT_EVENTS.FETCH_EMI_BANK_LIST_ERROR,
              error.message
            );
          }
        });
    } else {
      this.props.cache.getData(CACHE.STORE).setState({ stopScroll: true });
      this.setState({ showBankList: true, bankListError: '' });
    }
  };

  onOptionSelect = option => {
    const paymentOptions = { ...this.props.cache.getData('paymentOptions') };
    if (
      option.isHybridDisabled &&
      getKey(this.props, 'wallet.isUsed', false) &&
      isHybridOrAddNPay(paymentOptions, this.props.cache)
    ) {
      const emiLocale = clientMessage(PAYMODE.EMI.toLowerCase(), this.props.cache);
      const wallet = { ...paymentOptions.wallet, isUsed: false };
      paymentOptions.wallet = wallet;
      const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
      const amountPayable = calculateAmountPayable(txnAmount, paymentOptions.wallet);
      this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
      this.props.onWalletToggle(wallet);
      const text = getKey(
        emiLocale,
        'label.emiHybridDisabledText',
        'Paytm Balance and EMI cannot be used together for this payment'
      );
      this.props.onNotificationTextChange(text);
      this.props.onBtnTextChange(LOCALE.payButton.text + amountPayable);
    }
    /* if selected type is sc */
    if (option.type === 'sc') {
      this.setState({ showSavedCard: true, useAnotherCard: false, error: '' });
    }
    this.props.onOptionSelect(option);
    this.props.onPayChange(true);
  };

  hideBankList = () => {
    this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
    this.setState({ showBankList: false });
  };

  closeBankList = cardData => {
    // if card is disabled prevent the click
    if (cardData.isDisabled) {
      return;
    }
    let request = {
      bankCode: cardData.bankCode,
      cardType: cardData.cardType,
      bankName: cardData.bankName,
      bankLogoUrl: cardData.bankLogoUrl
    };
    this.setState({ loader: true, error: '', activeBank: request });
    log({
      eventType: EVENTS.EMI_FETCH_PLANS,
      bankCode: request.bankCode,
      cardType: request.cardType
    });
    this.props.updateSelectedPayModePcfWithInstId(cardData.bankCode);
    request = updatePayloadForTenureEMI(this.props.cache, request);
    emiApi(this.props.cache)
      .getEmiPlans(request)
      .then(response => {
        this.setState({ showBankList: false, loader: false });
        const { emiPlans, isHybridDisabled } = response;

        if (emiPlans) {
          const paymentOptions = { ...this.props.cache.getData('paymentOptions') };
          const savedInstruments = getKey(paymentOptions, 'merchantPayOption.savedInstruments', []);
          this.props.cache.setData(CACHE.PLAN_DETAILS, response);
          this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
          this.props.onSelectedPlan(null);

          if (this.frame) {
            this.frame.postDataToIframe({ type: CONSTANT.REMOVE_CARD_NUMBER });
            this.frame.postDataToIframe({ type: CONSTANT.HIDE_SAVED_CARD_AND_PLAN });
            /* if frame exists after selecting bank scroll to the same */
            // this.scrollToInputField();
          }

          if (isHybridDisabled) {
            this.disableWallet(paymentOptions);
          }

          const { bankCode, cardType, bankName } = emiPlans;
          if (bankCode && cardType && bankName) {
            const matchedEmiBankSavedCards = this.getSelectedEmiBankMatchedSavedCards(
              savedInstruments,
              cardType,
              bankCode
            );

            if (matchedEmiBankSavedCards && matchedEmiBankSavedCards.length) {
              this.props.onOptionSelect(matchedEmiBankSavedCards[0]);
              this.setState({
                bankLabel: bankName,
                showSavedCard: true,
                savedCardPayMode: matchedEmiBankSavedCards,
                selectedCard: true,
                useAnotherCard: false
              });
              // const defaultSelectedPaymodeOffSetTop = getKey(
              //   this.props.selected,
              //   'reference._component.componentRef.offsetTop',
              //   0
              // );
              /* scrolling 131 which is the height of sc with cvv iframe */
              // scrollWithTimeout(defaultSelectedPaymodeOffSetTop + 131);
            } else {
              /* if new card is alredy being used and on bank change again post msg to iframe */
              if (this.state.useAnotherCard) {
                this.postMessageToHideCVVExpiry();
              }
              this.setState({
                bankLabel: bankName,
                useAnotherCard: true,
                selectedCard: false,
                savedCardPayMode: null,
                showSavedCard: false
              });
              this.updateinitializeObject();
            }
          } else {
            this.setBankError(cardData);
          }
        } else {
          this.setBankError(cardData);
        }
      })
      .catch(err => {
        log({
          eventType: EVENTS.EMI_FETCH_PLANS_ERROR,
          error: err.message
        });
        this.hideLoaderInIframe();
        this.setBankError(cardData);
      });
  };

  getSelectedEmiBankMatchedSavedCards(savedInstruments, cardType, bankCode) {
    return (savedInstruments || []).reduce((acc, cur) => {
      if (
        getKey(cur, 'cardDetails.cardType') === cardType &&
        cur.issuingBank === bankCode &&
        cur.isEmiAvailable
      ) {
        const newPayMode = {
          ...cur,
          id: `emi-${cur.id}`,
          isEmiSc: true
        };
        delete newPayMode.reference;
        acc.push(newPayMode);
      }
      return acc;
    }, []);
  }

  disableWallet(paymentOptions) {
    const wallet = { ...paymentOptions.wallet, isUsed: false };
    this.props.cache.setData(CACHE.PAYMENT_OPTIONS, {
      ...paymentOptions,
      wallet
    });
    this.props.onWalletToggle(wallet);
  }

  setBankError = cardData => {
    const emiBankList = this.props.cache.getData(CACHE.EMI_BANK_LIST);
    // finding the index of the emi type in emi bank list
    const index = findIndex(emiBankList, list => list.type === cardData.emiType);
    emiBankList[index].cardTypes.forEach(card => {
      if (card.cardType === cardData.cardType && card.bankCode === cardData.bankCode) {
        // setting the disabled key for the bank to show in bank list
        card.isDisabled = true;
      }
    });
    this.props.cache.setData(CACHE.EMI_BANK_LIST, emiBankList);

    const locale = clientMessage(PAYMODE.EMI.toLowerCase(), this.props.cache);
    this.setState({
      loader: false,
      bankError: true,
      errorHeading: locale.error.emiBankListErrorHeading,
      errorSubText: locale.error.emiBankListErrorSubtext
    });
  };

  hideEmiPlans = () => {
    this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
    this.setState({ showEmiPlans: false });
  };

  getEMIPlans = payload => {
    this.setState({ loader: true, error: '' });
    log({
      eventType: EVENTS.EMI_FETCH_PLANS,
      bankCode: payload.bankCode,
      cardType: payload.cardType
    });
    payload = updatePayloadForTenureEMI(this.props.cache, payload);
    emiApi(this.props.cache)
      .getEmiPlans(payload)
      .then(data => {
        this.props.cache.getData(CACHE.STORE).setState({ stopScroll: true });
        this.setState({ loader: false });
        this.props.cache.setData(CACHE.PLAN_DETAILS, data);
        this.setState({ showEmiPlans: true });
        this.hideLoaderInIframe();
      })
      .catch(err => {
        log({
          eventType: EVENTS.EMI_FETCH_PLANS_ERROR,
          error: err.message
        });
        this.hideLoaderInIframe();
        this.setState({ error: err.message, loader: false });
      });
  };

  hideLoaderInIframe = () => {
    const postMessageIframeObj = {
      type: CONSTANT.HIDE_RING_LODER
    };
    this.frame && this.frame.postDataToIframe(postMessageIframeObj);
  };

  messageHandler = event => {
    if (
      !this.props.cache.getData(CACHE.STORE) ||
      getKey(event, 'data.calledFrom') !== 'emi' ||
      getKey(event, 'data.instanceKey') !== this.props.instanceKey
    ) {
      return;
    }

    const notifyMerchant = getKey(
      this.props.cache.getData(CACHE.MERCHANT_CONFIG),
      'handler.notifyMerchant',
      undefined
    );

    if (typeof getKey(event, 'data.type') === 'string') {
      switch (event.data.type) {
        case CONSTANT.PAY_SUCCESS: {
          this.props.onOverlayValueChange(CONSTANT.PROCESSING);
          const response = getKey(event, 'data.response', undefined);
          const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', {});
          response.body.content = content;
          response.body.callbackUrl = actionUrl;
          postInWindow(response, this.props.cache);
          break;
        }
        case CONSTANT.PAY_FAIL: {
          const data = event.data.response;
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, data);
          }
          if (
            getKey(data, 'body.resultInfo.resultStatus') === 'F' &&
            getKey(data, 'body.resultInfo.retry') === false
          ) {
            data.body.content = data.body.txnInfo;
            handlePostData(data, this.props.cache);
          } else if (
            getKey(data, 'body.resultInfo.resultStatus') === 'F' &&
            getKey(data, 'body.resultInfo.retry') === true
          ) {
            this.props.cache.getData(CACHE.STORE).setState({
              overlayValue: CONSTANT.RETRY,
              retryMessage: getKey(data, 'body.resultInfo.resultMsg')
            });

            //  in case of reyr get fallback token from cache and set current access token
            //  and remove txn token to fetch new txn token
            if (this.props.cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
              const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
              const tokenData = this.props.cache.getData(CACHE.FALLBACK_TOKEN_DATA, {
                token: getKey(mConfig, 'data.token', ''),
                tokenType: TOKEN.ACCESS
              });
              this.props.cache.setData(CACHE.TOKEN_DATA, {
                token: tokenData.token,
                tokenType: tokenData.tokenType
              });
            }
          }
          postInWindow(data, this.props.cache);
          break;
        }
        case CONSTANT.SESSION_EXPIRED: {
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, {
              message: CONSTANT.SESSION_EXPIRED
            });
          }
          this.props.onOverlayValueChange('');
          break;
        }
        case CONSTANT.SHOW_PROCESSING: {
          this.props.onOverlayValueChange(CONSTANT.PROCESSING);
          break;
        }
        case CONSTANT.INITIALIZED: {
          this.postMessageToHideCVVExpiry();
          break;
        }
        case 'CARD_NUMBER_FOCUS': {
          // this.scrollToInputField();
          break;
        }
        case CONSTANT.HIDECN: {
          this.frame &&
            this.frame.postDataToIframe({
              type: CONSTANT.HIDECN,
              paymode: { id: this.props.option.id, type: this.props.option.type }
            });
          break;
        }
        case CONSTANT.HIDECVVEXPIRY: {
          this.frame &&
            this.frame.postDataToIframe({
              type: CONSTANT.HIDECVVEXPIRY,
              paymode: { id: this.props.option.id, type: this.props.option.type }
            });
          break;
        }
        case CONSTANT.SHOW_EMI_PLAN_LIST: {
          this.setCardDetailsAndCallEmiPlans(event);
          break;
        }
        case CONSTANT.CLIENT_VALIDATION:
          log({ eventType: EVENT.CARD_EVENT_CLIENT_VALIDATION });
          postInWindow({}, this.props.cache); // close popup window as client side validation failed
          break;
        case CONSTANT.CARD_NOT_SUPPORTED: {
          log({
            eventType: 'Checkout_Card_Pay_Error',
            error: CONSTANT.CARD_NOT_SUPPORTED
          });
          break;
        }
        case CONSTANT.SET_VALIDATION_STATUS: {
          this.hasValidationError = getKey(event, 'data.hasError');
          break;
        }
        case CONSTANT.GET_TXN_TOKEN_PAYLOAD: {
          this.props.cache
            .getData(CACHE.API)
            .getAsyncPayload(API.PT, this.hasValidationError)
            .then(payload => {
              const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
              const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
              const orderId = this.props.cache.getData(CACHE.ORDER_ID);
              if (config && config.flow === FLOW.DEFERRED) {
                payload.data.body.orderId = orderId;
                payload.query.orderId = orderId;
              }
              const emiPlans = this.props.cache.getData(CACHE.EMI_PLANS);
              payload.data.body = { ...payload.data.body, ...payload.query };
              const reqData = {
                paymentMode: PAYMODE.EMI,
                type: CONSTANT.SUBMIT_WITH_TOKEN,
                targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
                queryParams: payload.query,
                method: payload.method,
                requestData: { ...payload.data },
                paymode: { id: this.props.option.id, type: this.props.option.type },
                guestFlow: tokenData.tokenType !== TOKEN.TXN || false,
                isEmi: true,
                planId: emiPlans && emiPlans.pgPlanId
              };
              this.frame && this.frame.postDataToIframe(reqData);
            })
            .catch(() => {
              this.props.onOverlayValueChange('');
            });
          break;
        }
        case CONSTANT.HELPER_TYPE.CVV_HELPER: {
          log({ eventType: EVENT.CARD_EVENT_CVV_HELPER });
          this.props.onHelperOverlayToggle(CONSTANT.HELPER_TYPE.CVV_HELPER);
          break;
        }
        case CONSTANT.UPDATE_HEIGHT: {
          this.updateIframeHeight(event.data.height);
          break;
        }
        case CONSTANT.LOG_CARD_DETAILS: {
          log({ eventType: EVENT.CARD_EVENT_CARD_DETAILS, ...event.data.detail });
          break;
        }
        case CONSTANT.HANDLE_PROMO_RESPONSE: {
          if (event.data.error) {
            this.props.handlePromoErrorFromCard(
              event.data.error,
              event.data.payMethod,
              event.data.bankCode
            );
          } else {
            this.props.handlePromoResponseFromCard(event.data.response, event.data.bankCode);
          }
          break;
        }
        case CONSTANT.CVV_EXPIRY_FOCUS: {
          // const iframeOffsetTop = getKey(this.frame, 'iframe.offsetTop', 0);
          // scrollWithTimeout(iframeOffsetTop + 100);

          break;
        }
        case CONSTANT.CACHE_CARD_TOKEN: {
          const token = getKey(event, 'data.token', null);
          this.props.cache.setData(CONSTANT.CACHE_CARD_TOKEN, token);
          break;
        }
        case CONSTANT.CARD_NUMBER_RESET:
          /* on card number reset remove any error if any */
          this.setState({ error: '' });
          break;
        default: {
          break;
        }
      }
    }
  };

  updateIframeHeight = (height = null) => {
    const iframe = getKey(this.frame, 'iframe');
    if (iframe) {
      iframe.style.minHeight = height;
    }
  };

  // scrollToInputField = () => {
  // const iframeOffsetTop = getKey(this.frame, 'iframe.offsetTop', 0);
  // scrollWithTimeout(iframeOffsetTop, 0);
  // };

  setCardDetailsAndCallEmiPlans = event => {
    const planDetails = this.props.cache.getData(CACHE.PLAN_DETAILS);
    const paymentIntent = [];
    if (this.props.wallet && this.props.wallet.isUsed) {
      paymentIntent.push({
        mode: PAYMODE.WALLET,
        txnAmount: this.props.wallet.walletBalance
      });
    }
    const cardDetails = getKey(event, 'data.cardDetails', null);
    const binDetail = getKey(event, 'data.cardDetails.details.binDetail', null);
    if (cardDetails && cardDetails.cardHash && binDetail) {
      paymentIntent.push({
        banks: [event.data.cardDetails.details.binDetail.issuingBankCode],
        cardHash: event.data.cardDetails.cardHash,
        channels: [event.data.cardDetails.details.binDetail.channelName],
        mode: PAYMODE.EMI,
        mode_type: event.data.cardDetails.details.binDetail.paymentMode,
        txnAmount:
          this.props.wallet && this.props.wallet.isUsed
            ? planDetails.payableAmount - this.props.wallet.walletBalance
            : planDetails.payableAmount
      });
      const payload = {
        bankCode: this.state.activeBank.bankCode,
        bankName: this.state.activeBank.bankName,
        cardType: this.state.activeBank.cardType,
        payment_intent: paymentIntent
      };
      this.props.cache.setData(CACHE.PAYMENT_INTENT, paymentIntent);
      this.setState({ payment_intent: paymentIntent, cardDetails: event.data.cardDetails });
      this.getEMIPlans(payload);
    } else {
      this.setState({ cardDetails });
      const payload = {
        bankCode: this.state.activeBank.bankCode,
        bankName: this.state.activeBank.bankName,
        cardType: this.state.activeBank.cardType
      };
      this.getEMIPlans(payload);
    }
  };

  selectNewCard = () => {
    this.props.setEmiOfferNull();
    this.setState({ useAnotherCard: true, error: '', loader: false });
    this.updateinitializeObject();
    /* on selecting new card setting emi plan in store to nul to fix the emi html height issue */
    this.props.onSelectedPlan(null);
  };

  setEmiPlan = plan => {
    this.setState({ selectedPlan: plan });
  };

  selectEmiPlan = plan => {
    this.setState({ loader: true });
    const itemHash = {};
    this.props.onSelectedPlan(plan);
    const planDetails = { ...this.props.cache.getData(CACHE.PLAN_DETAILS) };
    const paymentIntent = this.props.cache.getData(CACHE.PAYMENT_INTENT);

    getKey(planDetails, 'cart.cart_items', []).map(item => {
      const offerId = getKey(item, `emi_offers.${plan.planId}.offerId`);
      itemHash[item.item_id] = offerId ? { offer_id: offerId } : {};
      return item;
    });

    let requestPayload = {
      plan_id: plan.planId,
      pgPlanId: plan.pgPlanId,
      item_map: itemHash,
      payment_intent: paymentIntent,
      bankCode: planDetails.bankCode,
      planId: plan.planId // adding a duplicate since in another place this needs to be used and camel case is not being allowed by eslint
    };

    log({
      eventType: EVENTS.EMI_APPLY_PLAN,
      plan_id: plan.planId,
      item_map: itemHash
    });

    /* check for plans gratification to check whether the planselected is standard emi or subvented emi */
    const gratifications = getKey(plan, 'gratifications', []);
    const isStandardEmi = !gratifications.length;
    requestPayload = updatePayloadForValidateEMI(
      this.props.cache,
      plan,
      requestPayload,
      this.props.cache.getData(CONSTANT.CACHE_CARD_TOKEN)
    );
    /* if plan selected is not subvented emi call default flow function in case of validate emi that
     is  not to make validate emi api call */
    emiApi(this.props.cache, isStandardEmi)
      .applyEmi(requestPayload)
      .then(({ apiResponse, hasEmiPlans, fallBackAmount, txnAmount }) => {
        if (apiResponse) {
          const { emiSubventionToken } = apiResponse;
          this.props.cache.setData(CONSTANT.EMISUBVENTION_TOKEN, emiSubventionToken);
        }

        this.setState({ loader: false });

        if (!hasEmiPlans) {
          this.setState({
            bankError: true,
            errorHeading: 'Error',
            errorSubText: 'Selected Plan is not offered by bank'
          });
          return;
        }

        const paymentOptions = this.props.cache.getData('paymentOptions');
        const walletObj = { ...paymentOptions.wallet };
        this.props.cache.setData(CONSTANT.FALLBACK_TXN_AMOUNT, fallBackAmount);
        this.props.cache.setData(CONSTANT.TXN_AMOUNT, txnAmount);
        this.props.setPayableAmount(null, walletObj, paymentOptions, null, true);
        let gratification = getKey(plan, 'gratifications', null);
        if (gratification) {
          gratification = gratification[0];
        }

        let emiText = `EMI of ₹${plan.emi} for ${plan.interval} months @ ${plan.rate}% p.a.`;
        let totalText = `Total ₹ ${plan.effectivePrice}`;

        /* using string fromcodepoint to convert the entity to javascript object */
        emiText = convertRupeeCharToUnicode(emiText);
        totalText = convertRupeeCharToUnicode(totalText);
        const postMessageIframeObj = {
          type: CONSTANT.SHOW_SAVED_CARD_AND_PLAN,
          savedCard: this.state.cardDetails,
          plan,
          emiText,
          total: totalText
        };
        // setTimeout(() => {
        //   this.hiddenInputRef && this.hiddenInputRef.focus();
        // }, 0);

        if (gratification) {
          let gratificationText = `EMI offer of ₹${gratification.value} ${gratification.label} successfully applied`;
          gratificationText = convertRupeeCharToUnicode(gratificationText);
          postMessageIframeObj.gratification = gratificationText;
        }

        this.frame && this.frame.postDataToIframe(postMessageIframeObj);
        this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
        this.setState({ showEmiPlans: false, selectedPlan: plan, error: null });
        this.props.cache.setData(CACHE.EMI_PLANS, requestPayload);
      })
      .catch(err => {
        log({
          eventType: EVENTS.EMI_APPLY_PLAN_ERROR,
          error: err
        });
        this.props.onSelectedPlan(null);
        const locale = clientMessage(PAYMODE.EMI.toLowerCase(), this.props.cache);
        this.setState({
          loader: false,
          bankError: true,
          errorHeading: locale.error.emiPlanError,
          errorSubText: err.message || locale.error.emiPlanSubtext
        });
      });
  };

  showMiniCart = plan => {
    this.setState({ showMiniCart: true, selectedPlan: plan });
  };

  closeMiniCart = () => {
    this.setState({ showMiniCart: false });
  };

  submit = () => {
    if (this.state.useAnotherCard) {
      const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
      const payload = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
      const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
      const orderId = this.props.cache.getData(CACHE.ORDER_ID);
      if (config && config.flow === FLOW.DEFERRED) {
        payload.data.body.orderId = orderId;
        payload.query.orderId = orderId;
      }
      payload.data.body = { ...payload.query };
      const emiPlans = this.props.cache.getData(CACHE.EMI_PLANS);
      const reqData = {
        paymentMode: PAYMODE.EMI,
        type: CONSTANT.SUBMIT,
        targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
        queryParams: payload.query,
        method: payload.method,
        requestData: { ...payload.data },
        paymode: { id: this.props.option.id, type: this.props.option.type },
        isEmi: true,
        planId: emiPlans && emiPlans.pgPlanId,
        guestFlow: tokenData.tokenType !== TOKEN.TXN || false
      };
      !this.hasValidationError && openPopUpWindow(this.props.cache);
      this.frame && this.frame.postDataToIframe(reqData);
    } else if (
      this.props.selected &&
      this.props.selected.subOption &&
      this.props.selected.subOption &&
      this.props.selected.subOption.reference
    ) {
      this.props.selected.subOption.reference._component.submit();
    }
  };

  hideShowError = () => {
    this.setState({ bankError: false, errorHeading: '', errorSubText: '' });
  };

  postMessageToHideCVVExpiry = () => {
    this.frame &&
      this.frame.postDataToIframe({
        type: CONSTANT.HIDECVVEXPIRY,
        paymode: { id: this.props.option.id, type: this.props.option.type }
      });
  };

  render(
    { option, instanceKey, selected, isActive, offers, cache },
    {
      showBankList,
      bankLabel,
      savedCardPayMode,
      showSavedCard,
      useAnotherCard,
      initializeObject,
      showEmiPlans,
      selectedCard,
      showMiniCart,
      selectedPlan,
      loader,
      bankError,
      errorSubText,
      errorHeading,
      bankListError,
      error
    }
  ) {
    const planDetails = cache.getData(CACHE.PLAN_DETAILS);
    const locale = clientMessage(PAYMODE.EMI.toLowerCase(), cache);
    const emiFrameInitData = { ...initializeObject };
    const { onOptionSelect } = this;
    const emiOffer = getKey(offers, PAYMODE.EMI);

    const isEmiSubventionFlow = cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW);
    const miniCart = cache.getData(CONSTANT.SUBVENTION_MINI_CART_OBJ);
    return (
      <div
        className="ptm-emi-main"
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div className="ptm-pay-method ptm-w100-ib">
          <div
            className="ptm-radio-wrap ptm-pt11"
            onClick={() => {
              onOptionSelect(option);
            }}
          >
            <label className="ptm-lbl" htmlFor="emi-radio">
              <input
                type="radio"
                name={`verify-emi${instanceKey}`}
                id="emi-radio"
                checked={isActive}
              />
              <span className="ptm-checkmark" />
              <div className={`ptm-pay-method-cont`}>
                <p className={`ptm-paymode-name`}>EMI</p>
              </div>
            </label>
          </div>
          {option && isActive && (
            <div className={`ptm-emi-innermain`}>
              <div className={`ptm-emi-inner ptm-emi-innerwrap`}>
                <div
                  className={`ptm-emi-bank-select ptm-pos-r ptm-input-common ptm-select-bank ptm-body-color`}
                  onClick={this.getBankList}
                >
                  <span className={`ptm-emi-bank-txt ptm-body-color`}>{bankLabel}</span>
                  {/* to show loader only if bank label is select bank */}
                  {loader && bankLabel === 'Select Bank' && (
                    <div className={`ptm-select-loader`}>
                      <Loader />
                    </div>
                  )}
                </div>
                {bankListError && (
                  <div className="ptm-small-txt ptm-msg-red banklist-error">{bankListError}</div>
                )}
                {showSavedCard &&
                  savedCardPayMode.map((option, index) => {
                    const isDisplay = true;
                    const isActive = !!(
                      selected.subOption &&
                      selected.subOption.id === option.id &&
                      !useAnotherCard
                    );
                    return (
                      <SC
                        isEmi
                        key={index}
                        useAnotherCard={useAnotherCard}
                        {...{
                          option,
                          isDisplay,
                          isActive,
                          onOptionSelect
                        }}
                        ref={k => {
                          option.reference = k;
                        }}
                      />
                    );
                  })}

                {selectedCard && (
                  <div
                    className="ptm-radio-wrap ptm-pt11"
                    id="use-another-card"
                    onClick={() => {
                      this.selectNewCard();
                    }}
                  >
                    <label className="ptm-lbl">
                      <input
                        type="radio"
                        name={`verify${instanceKey}`}
                        id="use-another-card-radio"
                        checked={useAnotherCard}
                      />
                      <span className="ptm-checkmark" />
                      <div className={`ptm-pay-method-cont`}>
                        <p className={`ptm-paymode-name`}>Use Another Card</p>
                      </div>
                    </label>
                  </div>
                )}
                {useAnotherCard && (
                  <Iframe
                    ref={r => (this.frame = r)}
                    classname="ptm-card-iframe"
                    unload={this.updateIframeHeight}
                    postMessageHandler={this.messageHandler}
                    src={`${staticPath()}/assets/iframes/emi.html`}
                    initializeObject={emiFrameInitData}
                  />
                )}

                {error && <p className="ptm-small-txt ptm-msg-red">{error}</p>}
              </div>
              {showBankList && (
                <div className={`ptm-emi-overlay`}>
                  <OverlayWrap>
                    <EmiBankList
                      hideBankList={this.hideBankList}
                      closeBankList={this.closeBankList}
                    />
                  </OverlayWrap>
                  {loader && (
                    <div className={`ptm-loader-overlay`}>
                      <div className={`ptm-inn-load-wrap ptm-centralized ptm-pos-a`}>
                        <Loader />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {showEmiPlans && (
                <div className={`ptm-emi-overlay`}>
                  <OverlayWrap>
                    <EmiPlansList
                      planDetails={planDetails}
                      hideEmiPlans={this.hideEmiPlans}
                      setEmiPlan={this.setEmiPlan}
                      showMiniCart={this.showMiniCart}
                      selectEmiPlan={this.selectEmiPlan}
                      miniCart={miniCart}
                    />
                  </OverlayWrap>
                  {loader && (
                    <div className={`ptm-loader-overlay`}>
                      <div className={`ptm-inn-load-wrap ptm-centralized ptm-pos-a`}>
                        <Loader />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {showMiniCart &&
                (planDetails.cart || (isEmiSubventionFlow && miniCart)) &&
                selectedPlan && (
                  <div className={`ptm-emi-overlay`}>
                    <OverlayWrap>
                      <MiniCart
                        cart={planDetails.cart}
                        selectedPlan={selectedPlan}
                        closeMiniCart={this.closeMiniCart}
                        isEmiSubventionFlow={isEmiSubventionFlow}
                        miniCart={miniCart}
                      />
                    </OverlayWrap>
                  </div>
                )}

              {bankError && (
                <div className={`ptm-emi-overlay-bank-error`}>
                  <div className={`ptm-modal-wrapper ptm-body-bg`}>
                    <div className={`ptm-excl-box ptm-pos-r`}>
                      <span className={`ptm-centralized ptm-pos-a`}>!</span>
                    </div>
                    <h2 className={`ptm-body-color`}>{errorHeading}</h2>
                    <p className={`ptm-body-color`}>{errorSubText}</p>
                    <button onClick={this.hideShowError}>{locale.error.errorBtn}</button>
                  </div>
                </div>
              )}

              {emiOffer && <PaymodeOffer offer={emiOffer} />}
            </div>
          )}
          <p className={`ptm-global-bottom-border`} />
          {/* adding input for emi, since it cant be controlled from home */}
          {/* <input className={`ptm-hidden-input`} ref={r => (this.hiddenInputRef = r)} type={`tel`} /> */}
        </div>
      </div>
    );
  }
}

export default connect(
  'selected, AppStyle, wallet, selectedEmiPlan, cache, instanceKey',
  onChange
)(EMI);



// WEBPACK FOOTER //
// ./components/emi/index.js